<template>
  <div>
    <el-button size="medium" type="primary" @click="clickUpload">点击上传</el-button>
    <el-upload
      class="banner-upload"
      action="#"
      list-type="picture-card"
      :limit="parseInt('1')"
      :http-request="handleHttpRequest"
      :before-upload="beforeAvatarUpload"
      :on-change="uploadChange"
      :on-remove="uploadRemove"
      :class="{hide:hideUpload}"
      ref="upload"
      :file-list="initFile">
      <div v-if="!dialogImageUrl">未上传图片</div>
      <div slot="file" slot-scope="{file}">
        <img
          class="el-upload-list__item-thumbnail" :src="imgForm.imgPath"
        >
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" v-if="imgForm.imgPath" :src="imgForm.imgPath" alt="">
    </el-dialog>
    <div class="el-upload__tip">
      <p>提示：1. banner图片的大小为1200X100（像素）；</p>
      <p style="padding-left:43px;">2. 图片格式包括jpg、png、gif；</p>
      <p style="padding-left:43px;">3. 图片不超过2MB。</p>
    </div>
  </div>
</template>
<script>
import { postWfsImg, wfsImgUrl } from '@/api/common'
import { putNewsimgAdd, getNewsimgList, deleteNewsimgDel } from '@/api/newsimg'
// import { putNewsimgAdd, getNewsimgList, getNewsimgDetail, postNewsimgEdit, deleteNewsimgDel } from '@/api/newsimg'
const createForm = () => ({
  img: '',
  imgPath: '',
  orderNum: '',
  type: 2
})
export default {
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      hideUpload: false,
      limitCount: 1,
      initFile: [],
      disabled: false,
      imgForm: createForm(),
      imgId: null
    }
  },
  methods: {
    handleHttpRequest(option) {
      const formData = new FormData()
      if (option.data) {
        Object.keys(option.data).forEach(key => {
          formData.append(key, option.data[key])
        })
      }
      formData.append(option.filename, option.file)
      postWfsImg(formData).then(res => {
        console.log(res)
        this.imgForm.img = res.data.filePath
        this.imgForm.imgPath = wfsImgUrl(res.data.filePath)
        putNewsimgAdd(this.imgForm).then(res => {
          console.log(res)
          if (res.status === 1) {
            this.$message.success('上传成功')
            this.imgId = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    clickUpload() {
      document.getElementsByClassName('el-upload__input')[0].click()
    },
    uploadChange(file, fileList) {
      console.log(fileList)
      this.hideUpload = fileList.length >= this.limitCount
    },
    uploadRemove(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    handleRemove(file) {
      this.imgForm.img = ''
      this.imgForm.imgPath = ''
      this.initFile = []
      this.$refs.upload.handleRemove(file)
      deleteNewsimgDel(this.imgId).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
        }
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isType = /^image\/(jpeg|png|jpg|bmp)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isType) {
        this.$message.error('请选择图片文件进行上传!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isType && isLt2M
    },
    // 图片展示地址：WFS 文件名（无路径分隔符）走 /trace/wfs/img，旧 fileupload 数据回退原 imgUrl
    imgSrc(item) {
      if (item.img && item.img.indexOf('/') === -1) {
        return wfsImgUrl(item.img)
      }
      return item.imgUrl
    },
    getNewsimgListData() {
      getNewsimgList({
        page: 1,
        size: 100,
        type: 2
      }).then(res => {
        console.log(res)
        if (res.data.rows.length > 0) {
          const result = res.data.rows[res.data.rows.length - 1]
          this.imgForm.img = result.img
          this.imgForm.imgPath = this.imgSrc(result)
          this.imgId = result.id
          this.initFile.push({ name: '1', url: this.imgSrc(result) })
          this.hideUpload = true
        }
      })
    }
  },
  mounted() {
    this.getNewsimgListData()
  }
}
</script>
<style lang="scss">
.el-upload__tip {
  font-size: 14px;
  line-height: 30px;
}
.hide .el-upload--picture-card {
    display: none;
}
.el-upload-list__item {
  width: 100%;
}
.banner-upload {
  margin-top: 15px;
  .el-upload--picture-card {
    width: 100%;
  }
  .el-upload-list__item {
    width: 100%;
  }
}
</style>
